"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ThemeHelper = require("../Utilities/ThemeHelper");

var useStyles = (0, _ThemeHelper.makeStyles)(function (theme) {
  return {
    root: {},
    entered: {
      overflow: "visible"
    },
    startIcon: {
      display: "flex",
      alignItems: "center",
      marginRight: theme.spacing(2)
    },
    removeMarginExpanded: {
      // Need extra specificity
      "&.prmbl-expansionPanel": {
        // We don't want space between expansion panels
        margin: "auto",
        // We do want the border, though
        "&:before": {
          opacity: "1"
        },
        "& + .prmbl-expansionPanel:before": {
          display: "block"
        }
      }
    },
    // ExpansionPanel classes
    expanded: {},
    rounded: {},
    disabled: {}
  };
});
var _default = useStyles;
exports.default = _default;